// extracted by mini-css-extract-plugin
module.exports = {"orangeCardOuter":"_3BZZG"};